<template>
    <el-row>
      <el-col :span="24">

        <br />

        <h2>Sharers Summary</h2>
        <sharers-bar-chart v-if="sharers.length >= 0" :sharer-data="sharers" />

        <xolas-table
          hide-org-badge
          table-ref="sharingtable"

          title=""
          icon="fa fa-users"

          url="stats/org/20/null/telco"

          sort-field="sitesTotal"
          sort-direction="desc"
          :show-search="false"

          :fields="fields"

          track-by="organisation_id">

          <!-- XOL-696: the counting rule, right above the column headers -->
          <template #below-filter>
            <p class="sharing-summary__count-rule" data-testid="sharing-summary-count-rule">
              <i class="fa fa-info-circle" aria-hidden="true"></i><span>Counts include sharers whose licence is Active or Expired. Dismantled also counts Terminated sharers, so the columns need not add up to Total. Ratio % is the telco's share of Active and Expired licences.</span>
            </p>
          </template>

          <template #details="scope">
            <popup-sharer-stats :row-data="scope.rowData" />
          </template>

        </xolas-table>

    </el-col>
  </el-row>

</template>


<script>

import PostMixins from '@/mixins/PostMixins'

import SharersBarChart from '@/components/dashboard/charts/SharersBarChart'
import PopupSharerStats from '@/components/dashboard/sharers/PopupSharerStats'


export default {

  mixins: [PostMixins],

  components: {
    PopupSharerStats,
    SharersBarChart
  },



  props: {

    hideOrgBadge: {
      type: Boolean,
      default: false
    },

    titleClass: {
      type: String,
      default: null
    }

  },


  methods: {

    processData(data) {
      this.sharers = data
    }

  },


  data () {
    return {
      sharers: [],
      // minWidth hints mirror the pre-migration vuetable-2 render, measured at
      // 1504px viewport (.context/xol-234-baselines/metrics.json,
      // sharing-summary-report[0]) — el-table distributes un-sized columns
      // equally, which does not match the legacy content-based auto layout.
      // '__slot:details' baseline width rounds to 0 (an unlabelled popup-details
      // trigger cell) — no minWidth added.
      fields: [
        {
          title: 'Name',
          name: 'shortName',
          minWidth: 69
        },
        {
          title: 'Total',
          name: 'sitesTotal',
          titleClass: 'text-black',
          dataClass: 'text-black',
          minWidth: 57
        },
        {
          title: '% sites',
          name: 'percentSites',
          titleClass: 'hidden-sm-and-down text-info',
          dataClass: 'hidden-sm-and-down text-center text-info',
          minWidth: 78
        },
        {
          title: 'Active',
          name: 'sitesActive',
          titleClass: 'hidden-md-and-down text-primary',
          dataClass: 'hidden-md-and-down text-center text-primary',
          minWidth: 72
        },
        {
          title: 'New',
          name: 'sitesNew',
          titleClass: 'hidden-md-and-down text-success',
          dataClass: 'hidden-md-and-down text-center text-success',
          minWidth: 52
        },
        {
          title: 'Exclusive',
          name: 'sitesExclusive',
          titleClass: 'hidden-md-and-down text-black',
          dataClass: 'hidden-md-and-down text-center text-black',
          minWidth: 108
        },
        {
          title: 'Candidate',
          name: 'sitesCandidate',
          titleClass: 'hidden-md-and-down text-warning',
          dataClass: 'hidden-md-and-down text-center text-warning',
          minWidth: 111
        },
        {
          title: 'Temporary',
          name: 'sitesTemporary',
          titleClass: 'hidden-md-and-down text-info',
          dataClass: 'hidden-md-and-down text-center',
          minWidth: 125
        },
        {
          title: 'Dismantled',
          name: 'sitesDismantled',
          titleClass: 'hidden-md-and-down text-danger',
          dataClass: 'hidden-md-and-down text-center text-danger',
          minWidth: 132
        },
        {
          title: 'Ratio %',
          name: 'sharingRatio',
          sortField: 'sharingRatio',
          minWidth: 83
        },
        {
          name: '__slot:details'
        }
      ]
    }
  },

  created () {
    this.fetchData('stats/org/20/null/telco', this.processData)
  }


}
</script>

<!-- Dev-parity: zero horizontal cell padding + tight line-height to match the
     legacy vuetable-2 render (dev <td> uses `12px 0`). -->
<style scoped>
::v-deep .el-table th .cell,
::v-deep .el-table td .cell { padding-left: 0; padding-right: 0; }
::v-deep .el-table th .cell { white-space: normal; }
::v-deep .el-table th .cell,
::v-deep .el-table td .cell { line-height: 1.25; }

/* XOL-696: counting-rule note — the Activity changes "coalesced note" recipe (design-system §9),
   kept local like the XOL-586 copy. #606266 on white is AA at 12px (never .text-muted). */
.sharing-summary__count-rule { margin: 0 0 12px; font-size: 12px; line-height: 18px; color: #606266; }
.sharing-summary__count-rule .fa { margin-right: 6px; }
</style>
